import { Field } from 'types/AwardsFile'

const slugList: any = {
  detail: [
    'LorbJplL',
    'pVOyOXZA',
    'xWJjelYB',
    'mjENoNOw',
    'LwqByrRl',
    'jwvWZqwk',
    'NOdREYgQ',
    'QezrKaWx',
    'eYDoxqLZ',
    'mWxdMLjY',
    'zlVOJyJG',
    'genXpmpb',
    'EpEBOmdE',
    'JNZpBwDo',
    'vgDddMqr',
    'OJPZNMdp',
  ],
  strategy: [
    'jPAOZyAP',
    'VwEmRpNQ',
    'yAbmjGMz',
    'QRYQnwrm',
    'wAGlrxJM',
    'YPaAykOy',
    'zXBExMgZ',
    'pqJVdDOw',
    'WGEboMDl',
    'XjAydBWw',
    'zmNJQrWx',
    'POjYyVjN',
    'pymbbPaO',
    'YWROpzxJ',
    'mZERgPbQ',
    'NKrgbWBM',
    'pAoXAoxv',
    'bpWEnpBB',
    'kddVWYNA',
    'dqlrJrYo',
    'DawNqGXo',
    'pDZLdxGL',
    'ldVAAXPr',
    'obEDzVnx',
    'wEMkbRDg',
    'nJZwYqzD',
    'OxrnpvDL',
    'eKKDeWVX',
    'JjqmdroM',
    'rDPKZnVM',
    'nKAoOber',
    'GRNJDlEd',
    'LOyXRMaw',
    'AGQqxxWW',
    'lKXJYOXo',
    'nkRmAENQ',
    'xElEdBnl',
    'PzrYelNw',
    'xJrzpMye',
    'mnVjOAar',
    'WVoZJaJz',
    'GJeXpazq',
    'LEEgJzQl',
  ],
  creative: [
    'MzKokQRw',
    'yrwzZYZN',
    'qBAbgVwn',
    'vdBDyVYz',
    'WwOYxkdM',
    'oXlbBNrR',
    'zmqpPJnO',
    'YNoLLawq',
    'beypkWBE',
    'YNoKxKbl',
    'DMJqolpq',
    'kKrAZLZb',
    'mMxPKgAO',
    'OVxXNWNg',
    'QrVVnAjJ',
    'MpYaJZJz',
    'lEegjJxK',
    'ZgmDEmbw',
    'jxwevkDY',
    'nDBmpdyq',
    'eGooZdMj',
    'YrOgMWOG',
    'ZwVKLbPp',
    'dLwoJyjL',
    'YXanNAop',
    'KqoJJLrM',
    'yaxdDLAV',
    'BYKGQjpo',
    'QVDzOANO',
    'mDxpXrJg',
    'GaQaNAqO',
    'VekwGZoE',
    'OnMaJJNG',
    'maQjvYoN',
    'DeVppyQA',
    'NYOgvoew',
    'jxmzazOY',
    'zGvNEEpW',
    'rQVvEnXO',
    'DdQZoqWR',
    'AnyLJoYd',
    'NYDAVgXa',
    'GyKxbERG',
    'OyGQwXkE',
    'xYlrWmNa',
    'YAveeMyJ',
    'YAveeMyJ',
    'ebnlYBBN',
    'qLpMMJDW',
    'LOEzObKB',
    'KybMgWaz',
  ],
  impact: [
    'KWQGzPWL',
    'ODWXEoeB',
    'RmnBAbDr',
    'VYbjMjVM',
    'nVXNZgBw',
    'pdzlaveb',
    'bYWKoxlo',
    'rxGdnEqB',
    'okGpyvAR',
    'NPjnZgNN',
    'DPJYGggJ',
    'WZJWqKzW',
    'PYvbAYKe',
    'dGGVnEBg',
    'zQJJwZZe',
    'DGqwQZWE',
    'jywvNXDw',
    'adOdeEnj',
    'MYrdvNYd',
    'vZLxNpeA',
    'dEannlBx',
    'bqrYXdaj',
    'YxLZDBzQ',
    'JzOadvjz',
    'opbMdlNB',
    'OazZZVxk',
    'mWnqNWkv',
    'dBqLYzQv',
    'VyNyRLLj',
    'QrvVLBxQ',
    'LwYreEzX',
    'bxLgAPMa',
    'jAeGloYM',
    'MJvZwGJp',
    'vPEnGayq',
    'pzjMQKek',
    'BbXxeQeJ',
    'gayPwrQZ',
    'pDNDeWWZ',
    'gPdxdqyZ',
    'EJZBJGDp',
  ],
}

export const getBySlug = (fields: any, slug: string) => {
  return fields
    .filter((field: Field) => slugList[slug].includes(field.slug))
    .map((el: Field) => ({ title: el.label, text: el.value }))
}
